"use client";

import { useEffect } from "react";

//const API_BASE = process.env.NEXT_PUBLIC_API_URL || "http://localhost:4000";
const API_BASE = process.env.NEXT_PUBLIC_API_URL || "https://checkinoutpro.com";

export function useAnalyticsTracker(companyId?: string) {
  useEffect(() => {
    // Track visitor
    fetch(`${API_BASE}/api/tracking/visitor`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        page: window.location.pathname,
        companyId,
      }),
    }).catch((err) => console.error("Visitor tracking failed:", err));

    // Track impression
    fetch(`${API_BASE}/api/tracking/impression`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        type: "pageView",
        page: window.location.pathname,
        companyId,
      }),
    }).catch((err) => console.error("Impression tracking failed:", err));
  }, [companyId]);
}
